import React, { useState } from 'react';
import './SupportVisualisationEmbeddedApiTest.scss';
import { Button } from '@instinet-analytics/semantic-ui-components';
import { TextInput } from '@instinet-analytics/semantic-ui-components';
import { useServices } from 'app/hooks';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';
import { SetOrderIdsMessagePayload } from 'embedded/api/in/messages/SetOrderIdsMessagePayload';
import { SetPositionsMessagePayload } from 'embedded/api/in/messages/SetPositionsMessagePayload';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';

export default function SupportVisualisationEmbeddedApiTestIn() {
    const [orderIds, setOrderIds] = useState('');
    const [orderIdsRequest, setOrderIdsRequest] = useState<
        SetOrderIdsMessagePayload | undefined
    >(undefined);
    const [orderIdsResponse, setOrderIdsResponse] = useState('');
    const [positions, setPositions] = useState('');
    const [positionsRequest, setPositionsRequest] = useState<
        SetPositionsMessagePayload | undefined | { value: string }
    >(undefined);
    const [positionsResponse, setPositionsResponse] = useState('');

    const { embeddedApiService } = useServices();
    const { symbology } = useSelectAppSettings();

    const sendOrderIds = () => {
        const payload = { orderIds: orderIds.split(',') };
        setOrderIdsRequest(payload);
        setOrderIdsResponse('(pending)');
        embeddedApiService
            .receiveMessage('SET_ORDER_IDS', payload)
            .then(setOrderIdsResponse)
            .catch(setOrderIdsResponse);
    };
    const sendPositions = () => {
        setPositionsRequest(undefined);
        setPositionsResponse('');

        let payload: SetPositionsMessagePayload | undefined = undefined;

        try {
            payload = { symbology, positions: getPositions(positions) };
            setPositionsRequest(payload);
        } catch (err) {
            setPositionsRequest({ value: positions });
            setPositionsResponse((err as Error).message);
            return;
        }

        setPositionsResponse('(pending)');
        embeddedApiService
            .receiveMessage('SET_POSITIONS', payload)
            .then(setPositionsResponse)
            .catch(setPositionsResponse);
    };

    return (
        <div className="SupportVisualisationEmbeddedApiTestIn">
            <div className="topic">
                <h2>Send Order Ids</h2>
                <div className="form">
                    <div className="title">Order Ids: </div>
                    <TextInput
                        placeholder={'Comma Delimited Order Ids'}
                        onChange={setOrderIds}
                        value={orderIds}
                    />
                    <Button primary onClick={sendOrderIds}>
                        Send
                    </Button>
                </div>
                <div className="results">
                    {orderIdsRequest && (
                        <div className="title">
                            <div>Request</div>
                            <div>Response</div>
                        </div>
                    )}
                    <div>
                        <div>
                            {orderIdsRequest && (
                                <JsonPanel data={orderIdsRequest} />
                            )}
                        </div>
                        <div>
                            {orderIdsResponse && (
                                <JsonPanel data={orderIdsResponse} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="topic">
                <h2>Send Positions</h2>
                <div className="form">
                    <div className="title">Positions: </div>
                    <TextInput
                        placeholder={'Comma Delimited Symbol|Side|Quantity'}
                        onChange={setPositions}
                        value={positions}
                    />
                    <Button primary onClick={sendPositions}>
                        Send
                    </Button>
                </div>
                <div className="results">
                    {positionsRequest && (
                        <div className="title">
                            <div>Request</div>
                            <div>Response</div>
                        </div>
                    )}
                    <div>
                        <div>
                            {positionsRequest && (
                                <JsonPanel data={positionsRequest} />
                            )}
                        </div>
                        <div>
                            {positionsResponse && (
                                <JsonPanel data={positionsResponse} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function getPositions(
    positions: string
): Array<{ symbol: string; side?: 'B' | 'S' | 'SS'; qty?: number }> {
    return positions.split(',').map((p) => {
        const segments = p.split('|');
        return {
            symbol: segments[0],
            side: segments[1] as 'B' | 'S' | 'SS',
            qty: segments[2] ? parseInt(segments[2]) : undefined,
        };
    });
}
